/* eslint-disable max-lines */

export const config = {
    name: 'monthProgressReport',
    selection: true,
    index: false,
    searchFields: [
        {
            name: '年份',
            value: 'year',
            isFixed: true,
            type: 'date',
            timeType: 'year',
            format: 'yyyy',
            valueFormat: 'yyyy',
            span: 4
        },
        {
            name: '标题',
            value: 'title',
            isFixed: true,
            type: 'input',
            span: 4
        }
    ],
    columns: [
        {
            label: '月度进度表ID',
            prop: 'id',
            width: 120
        },
        {
            label: '标题',
            prop: 'title',
            width: 120
        },
        {
            label: '部门',
            prop: 'deptName',
            width: 120
        },
        {
            label: '年份',
            prop: 'year'
        },
        {
            label: '1 月累计达成率目标 (%)',
            width: 150,
            prop: 'month1Rate'
        },
        {
            label: '2 月累计达成率目标 (%)',
            width: 150,
            prop: 'month2Rate'
        },
        {
            label: '3 月累计达成率目标 (%)',
            width: 150,
            prop: 'month3Rate'
        },
        {
            label: '4 月累计达成率目标 (%)',
            width: 150,
            prop: 'month4Rate'
        },
        {
            label: '5 月累计达成率目标 (%)',
            width: 150,
            prop: 'month5Rate'
        },
        {
            label: '6 月累计达成率目标 (%)',
            width: 150,
            prop: 'month6Rate'
        },
        {
            label: '7 月累计达成率目标 (%)',
            width: 150,
            prop: 'month7Rate'
        },
        {
            label: '8 月累计达成率目标 (%)',
            width: 150,
            prop: 'month8Rate'
        },
        {
            label: '9 月累计达成率目标 (%)',
            width: 150,
            prop: 'month9Rate'
        },
        {
            label: '10 月累计达成率目标 (%)',
            width: 160,
            prop: 'month10Rate'
        },
        {
            label: '11 月累计达成率目标 (%)',
            width: 160,
            prop: 'month11Rate'
        },
        {
            label: '12 月累计达成率目标 (%)',
            width: 160,
            prop: 'month12Rate'
        },
        {
            label: '状态',
            prop: 'enableFlag',
            sortable: true,
            type: 'slot',
            slot: true,
            editSlot: true
        },
        {
            label: '创建人',
            prop: 'createUserName'
        },
        {
            label: '创建时间',
            prop: 'createTime',
            width: 160
        },
        {
            label: '修改人',
            prop: 'updateUserName'
        },
        {
            label: '修改时间',
            prop: 'updateTime',
            width: 160
        }
    ]
};
